export default __webpack_public_path__ + "static/media/heating.a76cbb49.png";